import { BaseApiAuth } from '@/api/BaseApiAuth'
import { MunMeh as Data, MunMehCollection as Collection } from '@/typings/api/MunMeh'
import { AxiosRequestConfig } from 'axios'
import { BaseApiResponse as BR } from '@/typings/common'

export class MunMehApi extends BaseApiAuth<Data, Collection> {
    protected readonly endpoint = 'munmeh';

    public parseFormdata(id: Data['id'], p: { file?: File; munmeh_to_copy?: string }, config?: AxiosRequestConfig) {
      const path = `${id}/formdata-parse/`
      const [url] = this.getUrl(path, p)
      const data = new FormData()
      if (p.file) data.append('file', p.file)
      if (p.munmeh_to_copy) data.append('munmeh_to_copy', p.munmeh_to_copy)
      return this.request('POST', url, { data, ...config })
    }

    public addParticipants(id: Data['id'], data: Record<string, unknown>, config?: AxiosRequestConfig) {
      const path = `${id}/add-participants/`
      const [url] = this.getUrl(path, data)
      return this.request('POST', url, { data, ...config })
    }

    public removeParticipants(id: Data['id'], data: Record<string, unknown>, config?: AxiosRequestConfig) {
      const path = `${id}/remove-participants/`
      const [url] = this.getUrl(path, data)
      return this.request('POST', url, { data, ...config })
    }

    public importCurators(id: Data['id'], file: File, config?: AxiosRequestConfig) {
      const path = `${id}/import-curators/`
      const [url] = this.getUrl(path)
      const data = new FormData()
      data.append('file', file)
      return this.request<never, BR<Data['id']>>('POST', url, { data, ...config })
    }

    public checkForms(id: Data['id'], config?: AxiosRequestConfig) {
      const path = `${id}/check-forms/`
      const [url] = this.getUrl(path)
      return this.request<never, BR<Data['id']>>('POST', url, config)
    }

    public deleteExpert1(id: Data['id'], config?: AxiosRequestConfig) {
      const path = `${id}/delete-experts/`
      const [url] = this.getUrl(path)
      return this.request<never, BR<Data['id']>>('POST', url, config)
    }

    public createFormTemplate(id: Data['id'], config?: AxiosRequestConfig) {
      const path = `${id}/create-xlsx/`
      const [url] = this.getUrl(path)
      return this.request<never, BR<Data['id']>>('POST', url, config)
    }
}
